import React, { useState, useEffect, createContext } from 'react';
import { isClientEnv } from '@app/src/utils/validations';
import { SearchInputModal } from './SearchInputModal';
import { SearchInput } from './SearchInput';
import { ErrorMessage } from './styled';

const isClient = isClientEnv();
const BREAKPOINT = 768;

interface Props {
  error?: string;
  input?: any;
  disabled?: boolean;
  isLoading?: boolean;
  handleChange?: Function;
  handleChangeInput?: Function;
  handleBlurInput?: Function;
  handleClickClose?: Function;
  handleClickOpenModal?: Function;
  defaultJob?: string;
  dataList?: any;
  message?: string;
  placeholder?: string;
  isLoadingModal?: string;
  activeColor?: string;
  minCharForSearch?: number;
  lastWordFound?: string;
}

export const SearchJobContext = createContext(null);

export const SearchConstructor: React.FC<Props> = props => {

  const [isResponsive, setIsResponsive] = useState(false);

  useEffect(() => {
    if (isClient) {
      handleResizeWindow();
      window.addEventListener('resize', handleResizeWindow);
      return () => {
        window.removeEventListener('resize', handleResizeWindow);
      }
    }
  }, []);

  const handleResizeWindow = () => {
    if (window.innerWidth >= BREAKPOINT) {
      setIsResponsive(false);
    } else {
      setIsResponsive(true);
    }
  }

  return (
    <React.Fragment>
      <SearchJobContext.Provider value={props}>
        {
          isResponsive ?
          <SearchInputModal />
          :
          <SearchInput  />
        }
      </SearchJobContext.Provider>
      {props.error && <ErrorMessage>{props.error}</ErrorMessage>}
    </React.Fragment>
)};
